export const supplierRetailerUtils = {
  getRetailerDisplayNameFromRetailerId,
  getRetailerDisplayNameFromRetailerName,
  setRetailersActiveStatus,
  mapRetailersByIdToRetailerNames,
};

function getRetailerDisplayNameFromRetailerId({ supplierRetailers = [], retailer = {}, retailerId }) {
  if (retailer?.retailer_display_name) {
    return retailer.retailer_display_name;
  }

  const supplierRetailer = supplierRetailers?.find(
    (sr) => sr.retailer_id === Number(retailerId) || sr?.retailer?.id === Number(retailerId),
  );

  return supplierRetailer?.retailer_display_name || retailer.name || '';
}

function getRetailerDisplayNameFromRetailerName({ supplierRetailers = [], retailerName = '' }) {
  const supplierRetailer = supplierRetailers?.find((sr) => sr?.retailer?.name === retailerName);
  return supplierRetailer?.retailer_display_name || retailerName || '';
}

function setRetailersActiveStatus(retailers = []) {
  return retailers
    .filter((retailer) => !!retailer.last_order_date)
    .map((retailer) => ({
      ...retailer,
      active: !!retailer.approved_for_ecommerce || !!retailer.approved_for_replenishment,
    }));
}

function mapRetailersByIdToRetailerNames(supplierRetailers = [], retailers = []) {
  const retailerIdToNameEntries = retailers.map((retailer) => {
    const retailerName = supplierRetailerUtils.getRetailerDisplayNameFromRetailerId({
      supplierRetailers,
      retailer,
      retailerId: retailer.id,
    });
    return [retailer.id, retailerName];
  });

  return Object.fromEntries(retailerIdToNameEntries);
}
